import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { map, switchMap, catchError } from 'rxjs/operators';

import * as fromActions from '../actions/contributor-jobs.actions';
import { ContributorJobsService } from '../../services/contributor-jobs.service';
import { of } from 'rxjs';

@Injectable()
export class ContributorJobsEffects {

    constructor(
        private actions$: Actions,
        private jobsService: ContributorJobsService
    ) { }

    @Effect()
    init$ = this.actions$.pipe(
        ofType(fromActions.JOBS_ACTION_TYPES.LOAD),
        switchMap(() => this.jobsService.getDefaultJobs().pipe(
            map(jobs => new fromActions.Action_Jobs_Loaded(jobs)),
            catchError(_error => {
                console.error('Error loading default jobs', _error);
                return of(new fromActions.Action_Jobs_LoadError('Não foi possível carregar a lista padrão'));
            })
        ))
    );

}
